import type { InsuredPerson } from '../mite.types';

export const insuredPersonFormatting = (insurePerson: InsuredPerson) => ({
  ...insurePerson,
  firstName: insurePerson.firstName?.trim(),
  lastName: insurePerson.lastName?.trim(),
  middleName: insurePerson.middleName?.trim(),
});
